import { getterTree } from 'typed-vuex';
import initialState from './state';

const getters = getterTree(initialState, {
  hasErrors: (state) => !!state.errorMsgKeys.length,
});

export default getters;
